export const RPMVideo = (function() {
	'use strict';

	function init() {
		moveModals();
	}

	// Video modals are rendered inside the block; move them to <body> so no parent
	// stacking context or overflow can trap the fixed-position overlay
	function moveModals() {
		document.querySelectorAll('.rpmblock--video .modal--video').forEach((modal) => {
			document.body.appendChild(modal);
		});
	}

	return {
		init: init
	};
})();
